/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-09-21 11:52:34
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-09-21 11:58:30
 * @FilePath: /b2c_public_components/src/zz-new-report/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ZzNewReport from './src/index'
console.log(ZzNewReport)
ZzNewReport.install = function (Vue) {
  Vue.component(ZzNewReport.name, ZzNewReport)
}
export default ZzNewReport
